const listCollectionsSwatchGender = document.querySelectorAll('.list-collections__switch--gender');

listCollectionsSwatchGender.forEach(el => {
  el.addEventListener('click', function() {

    if (!el.classList.contains('active')) {
      const getGender = this.getAttribute('data-gender');
      const listCollectionsSlider = this.closest('.list-collections').querySelector('.list-collections__switch--slider');
      const mensGenderCollection = this.closest('.list-collections').querySelector('.list-collections__mens');
      const womensGenderCollection = this.closest('.list-collections').querySelector('.list-collections__womens');
      
      // 1- Remove Active Class
      el.closest('.list-collections__switch').querySelectorAll('.list-collections__switch--gender').forEach(btn => btn.classList.remove('active'));

      // 2- Add Active Class
      this.classList.add('active');

      // 3- Update Slider & Collection
      if (getGender == 'mens') {
        // Update Slider
        listCollectionsSlider.classList.remove('active-womens');
        listCollectionsSlider.classList.add('active-mens');

        // Update Collection
        mensGenderCollection.classList.add('active');
        womensGenderCollection.classList.remove('active');

      } else if (getGender == 'womens') {
        // Update Slider
        listCollectionsSlider.classList.remove('active-mens');
        listCollectionsSlider.classList.add('active-womens');

        // Update Collection
        womensGenderCollection.classList.add('active');
        mensGenderCollection.classList.remove('active')
      } 
    }
  })
})